import axios from 'axios'

function onFulfilled(config: any) {
  const { data: responseBody } = config

  if ('code' in responseBody) {
    if (+responseBody.code === 200) {
      return responseBody.data
    }
    return Promise.reject(responseBody.message)
  }

  return config.data
}

function onRejected(error: any) {
  const responseData = error.response?.data

  if (!responseData) {
    return Promise.reject(error)
  }

  const { message, code } = responseData

  if (message && code) {
    return Promise.reject(message)
  }

  return Promise.reject(responseData)
}

const ReportService = axios.create({
  baseURL: 'https://api.banksea.finance/monitor/report',
  withCredentials: false
})

ReportService.interceptors.response.use(
  onFulfilled, onRejected
)

export { ReportService }
